import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import { useClientStore } from '@/features/Clients/store';
import type {
  ClientResourceContainer,
  ClientResourcePersisted,
  Role,
} from '@/features/Clients/types';

interface UseClient {
  client: ComputedRef<ClientResourceContainer>;
  persistedClient: ComputedRef<
    ClientResourceContainer<ClientResourcePersisted> | undefined
  >;
  isPersistedClient: ComputedRef<boolean>;
}

export const useClient = (role: Role): UseClient => {
  const clientStore = useClientStore();

  const client: ComputedRef<ClientResourceContainer> = computed(() =>
    clientStore.getClientByRole(role),
  );

  // only persisted clients will have an id
  const isPersistedClient = computed(() => client.value?.data.id !== null);

  const persistedClient: ComputedRef<
    ClientResourceContainer<ClientResourcePersisted> | undefined
  > = computed(() => {
    if (isPersistedClient.value) {
      return client.value as ClientResourceContainer<ClientResourcePersisted>;
    }

    return undefined;
  });

  return {
    client,
    persistedClient,
    isPersistedClient,
  };
};
